import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormVerifyCustomerService } from '../services/form-verify-customer.service';
import { ConcentService } from '../services/concent.service';
import { FormRegistrationService } from '../services/form-registration.service';
import { LoaderService } from '../services/loader.service';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { LoggerService } from "../services/logger.service"
import { TermsAndConditionService } from '../services/terms-and-condition.service';
import { LineNotificationService } from '../services/line-notification.service';
import { Observable } from 'rxjs';
import { TelemedService } from '../services/telemed.service'
import { TelemedStateActionService } from '../statemanagement/telemed-state-action.service';
import { environment } from 'src/environments/environment';
import { AddTags } from '../models/telemed.model';
import liff from '@line/liff';
@Component({
    selector: 'app-daz-form-complete',
    templateUrl: './daz-form-complete.component.html',
    styleUrls: ['./daz-form-complete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DazFormCompleteComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private verifyCustomerService: FormVerifyCustomerService,
    private concentService: ConcentService,
    private formRegistrationService: FormRegistrationService,
    private loaderService: LoaderService,
    private lineActionService: LineStateActionService,
    private loggerService: LoggerService,
    private termsAndConditionService: TermsAndConditionService,
    private lineNotificationService: LineNotificationService,
    private telemedService: TelemedService,
    private telemedStateActionService: TelemedStateActionService
  ) { }
  headers = signal<any>(["ยินดีต้อนรับเข้าสู่", "บริการปรึกษาแพทย์ออนไลน์"]);
  body = "(ผู้ให้บริการ Doctor A to Z)"
  btnAccept = signal<string>("ใช้บริการเลย");
  btnNotAccept = "ใช้บริการเลย (not accept consent)";
  btnCancel = signal<string>("ภายหลัง");
  code = signal<string>("");
  description = "";
  isLoading = signal<boolean>(true);
  isShowButton = signal<boolean>(true);
  electronic_channel: number;

  async ngOnInit() {
    const channel = this.lineActionService.channelStateInfo;
    this.electronic_channel = channel.electronic_channel
    const responseAssignCoupon = await this.telemedService.telemedAssignCoupon(channel);
    if (responseAssignCoupon == "S201") {
      if (channel.dazDoctor || channel.dazSpecialty) {
        return this.getDataAndRedirectUrl();
      }
      //skip ไม่ต้อง assign สิทธิ์
      if (channel.comCode == "insure" && !channel.subflow) {
        return this.getDataAndRedirectUrl();
      }
      this.isShowButton.set(false);
      if (channel.lineTemplate) {
        this.sendNotification(channel.lineTemplate).subscribe();
      } else {
        this.sendNotification("DAZ_REDIRECT").subscribe();
        this.onSendMessage(false).subscribe();
      }
      this.addTag();
      window.location.href = 'https://line.me/R/oaMessage/' + channel.lineBotId

    }
    else if (responseAssignCoupon == "S200") {
      this.isShowButton.set(false);
      if (channel.lineTemplate) {
        this.sendNotification(channel.lineTemplate).subscribe();
      } else {
        this.sendNotification("DAZ_AUTO_ASSIGN_COUPON").subscribe();
        this.onSendMessage(false).subscribe();
      }
      this.addTag();
      window.location.href = 'https://line.me/R/oaMessage/' + channel.lineBotId
    } else {
      return await this.router.navigate(['../dazFormFail'], { relativeTo: this.route, queryParams: { code: responseAssignCoupon } });
    }

  }

  addTag() {
    const channel = this.lineActionService.channelStateInfo;
    if (channel.addTag) {
      this.addTagRef([channel.addTag]);
    }
  }
  async addTagRef(tags: Array<string>) {
    const channel = this.lineActionService.channelStateInfo;
    let payloadAddTags: AddTags = {
      // "channel_identity": channel.channel_identity,
      "electronic_channel": channel.electronic_channel,
      tags: []
    }
    tags.forEach(val => {
      payloadAddTags.tags.push({ "tagRef": val })
    })
    return this.telemedService.apiAddTagRef(payloadAddTags).subscribe();
  }

  onError() {
    const channel = this.lineActionService.channelStateInfo;
    window.location.href = 'https://line.me/R/oaMessage/' + channel.lineBotId
    // liff.closeWindow();
  }

  onSendMessage(first_use = true) {
    const channel = this.lineActionService.channelStateInfo;
    let body = {
      // "channel_identity": channel.channel_identity,
      "electronic_channel": channel.electronic_channel,
      "comcode": channel.comCode,
      "channel": channel.application_channel_reference,
      "first_use": first_use,
      "time_delay": channel.friendshipFlag ? 1000 : 8000
    }
    return this.telemedService.apiCheckAndPushMessage(body);
  }
  onAccept() {
    this.getDataAndRedirectUrl();
  }

  getDataAndRedirectUrl() {
    const channel = this.lineActionService.channelStateInfo;
    let body = {
      // "channel_identity": channel.channel_identity,
      "electronic_channel": channel.electronic_channel,
      "doctor_profile":channel.dazDoctor || null,
      "group_specialtys":channel.dazSpecialty || null
    }
    this.telemedService.apiGetInformationEncrypt(body).subscribe(response => {
      if (!response) {
        console.log(response);
        let payload = {
          ...channel,
          "template_ref": "ADS_ADDITIONAL_PRODUCT",
          "template_parameter": {}
        }
        this.lineNotificationService.sendNotificationWithTemplate(payload).subscribe(
          result => {
            console.log(['sendNotificationWithTemplate', result])
          },
          error => {
            console.log(['sendNotificationWithTemplate', error])
          }
        )
        this.addTag();
        window.location.href = 'https://line.me/R/oaMessage/' + channel.lineBotId
        return;
      }
      // add tag
      this.addTag();
      let url = response.payload;
      let dataEncodeURI = encodeURIComponent(url);
      console.log(environment.dazRedirectUrl + '/partner?data=' + dataEncodeURI)
      window.location.href = environment.dazRedirectUrl + '/partner?data=' + dataEncodeURI;
    },
      error => {
        console.log(error);
        this.code.set("error_102");
        this.description = "ขออภัย เกิดข้อผิดพลาดทำให้ไม่สามารถทำรายการต่อได้ครับ"
        this.loggerService.loggerInfo({ "error_102": "ขออภัย เกิดข้อผิดพลาดทำให้ไม่สามารถทำรายการต่อได้ครับ" });
        this.loggerService.loggerInfo({ "error_102": error.toString() });
        this.isLoading.set(false);
        this.isShowButton.set(false);
        return;
      })
  }

  sendNotification(template_ref: string = "DAZ_REDIRECT") {
    const channel = this.lineActionService.channelStateInfo;
    if (channel.lineTemplate) {
      template_ref = channel.lineTemplate;
    }
    let payload = {
      ...channel,
      "time_delay": channel.friendshipFlag ? 1000 : 7000,
      "template_ref": template_ref,
      "template_parameter": {
        "ref": (channel.refCode ? channel.refCode : "") + "-clone"
      }
    }
    console.log(['sendNotification', payload])
    return this.lineNotificationService.sendNotificationWithTemplate(payload)
  }

  getPrimaryColor() {
    if (this.electronic_channel === 20) return 'rgb(130, 188, 0)'
  }
  
}
